import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ requireSubscription }) {
  const { isAuthed, isLoading, subscriptionStatus } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-black">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white" style={{
          borderTopColor: '#22c55e', // green-600
          borderBottomColor: '#2563eb', // blue-600
        }}></div>
        <span className="ml-4 text-white font-bold text-lg">Checking authentication…</span>
      </div>
    );
  }

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requireSubscription && !['active', 'lifetime', 'trial', 'trialing'].includes(subscriptionStatus)) {
    return <Navigate to="/subscription" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
